import { render, staticRenderFns } from "./GmbPhoto.vue?vue&type=template&id=d48e0bda&scoped=true&"
import script from "./GmbPhoto.vue?vue&type=script&lang=js&"
export * from "./GmbPhoto.vue?vue&type=script&lang=js&"
import style0 from "./GmbPhoto.vue?vue&type=style&index=0&id=d48e0bda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d48e0bda",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
